import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

// Initialize Google Analytics
// Replace with your actual tracking ID
ReactGA.initialize('G-XXXXXXXXXX');

// Setup for react-snap prerendering
const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  // If the app is being hydrated by react-snap
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
} else {
  // Normal render for development and fresh loads
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
} 